Object.defineProperty(exports,"__esModule",{value:true});var warningsByCode={};exports.default=

null;

var warnOnceWithCode=exports.warnOnceWithCode=function warnOnceWithCode(code,warning){
if(!warningsByCode[code]){
warningsByCode[code]=true;
console.warn(warning);
}
};